import $ from "/srv/www/c/cuttingmatsxxl.com/vhosts/www/htdocs/content/mu-plugins/wp-soup-plugin/node_modules/jquery";
import Stepper from "bs-stepper";

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

$(document).ready(() => {
  var quickCaltranslate = wpCuttingMatData.translations.quick_cal_info;
  var quick_info_icon =
    '<span class="iconify icon-fw" data-icon="fas:info-circle"></span>';
  var quick_cal_info_menuItem = $(
    ".woocommerce-MyAccount-navigation-link--quickcalc a"
  );
  $(quick_cal_info_menuItem).append(
    `<span data-tooltip aria-haspopup='true' class='has-tip info' data-disable-hover='false' data-allow-html='true' tabindex='1' title="${quickCaltranslate}">${quick_info_icon}</span>`
  );
  // $("[data-tooltip").foundation();
  $(
    "#billing_last_name, #billing_first_name, #billing_postcode,  #billing_city,  #billing_phone, #billing_email "
  ).on("change paste keyup", function () {
    var checkouValues = $(
      "#billing_last_name, #billing_first_name, #billing_postcode , #billing_city , #billing_phone, #billing_email "
    ).val();
    if (checkouValues.length > 1) {
      $(".shipping-part").show();
    } else {
      $(".shipping-part").hide();
    }
  });
  var step4 = $(".step-4").hasClass("active");
  $(".payment-part").hide();
  $(".shipping-part").hide();
  // var step4 = $(".step-4").hasClass("active");
  if (step4 === true) {
    $(".payment-part").show();
  } else {
    $(".payment-part").hide();
  }

  const csrfTokenMeta = document.querySelector('[name="csrf-token"]');
  if (csrfTokenMeta) {
    const csrfInterval = setInterval(function () {
      const csrfInputs = document.querySelectorAll(
        '.woocommerce-checkout input[name="_token"]'
      );
      if (csrfInputs.length) {
        for (let input of csrfInputs) {
          if (input.value == "") {
            input.value = csrfTokenMeta.getAttribute("content");
            clearInterval(csrfInterval);
          }
        }
      } else {
        clearInterval(csrfInterval);
      }
    }, 1000);
  }

  const stepperEl = document.querySelector(".stepper");
  if (stepperEl) {
    const stepper = new Stepper(stepperEl);
    window.initializedStepper = stepper;

    stepperEl.addEventListener("show.bs-stepper", function (event) {
      // You can call preventDefault to stop the rendering of your step
      // event.preventDefault()
    });

    stepperEl.addEventListener("shown.bs-stepper", function (event) {});

    const nextButtons = document.querySelectorAll(".button.next");
    for (const nextButton of nextButtons) {
      nextButton.addEventListener("click", function (event) {
        stepper.next();
        $('input[name="payment_method"]').each(function () {
          this.checked = false;
        });
      });
    }

    const previousButtons = document.querySelectorAll(".button.previous");
    for (const previousButton of previousButtons) {
      previousButton.addEventListener("click", function (event) {
        stepper.previous();
      });
    }

    if (document.querySelector("body.woocommerce-cart")) {
      stepper.to(2);
    }
    if (document.querySelector("body.woocommerce-checkout")) {
      stepper.to(3);
    }
    if (
      document.querySelector(
        "body.woocommerce-checkout.woocommerce-order-received"
      )
    ) {
      stepper.to(5);
    }

    $(window).keydown(function (event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        return false;
      }
    });
  }

  $(".sticky")
    .on("sticky.zf.stuckto:top", function () {
      $(".slogan-block").addClass("hide");
      $(".main-menu-cta").addClass("hide");
      $(".top-menu-cta").removeClass("hide");
    })
    .on("sticky.zf.unstuckfrom:top", function () {
      $(".slogan-block").removeClass("hide");
      $(".main-menu-cta").removeClass("hide");
      $(".top-menu-cta").addClass("hide");
    });

  // Popup
  window.scrollTo(0, 0);
  const cuttingmatsXXLPopup = $(".cuttingmatsxxl-reveal");
  $(".funnelPopupBtn").on("click", function () {
    cuttingmatsXXLPopup.css("display", "none");
    cuttingmatsXXLPopup.hide();
    $("html").removeClass("is-reveal-open");
    $(".reveal-overlay").css("display", "none");

    setCookie('new_site_popup_viewed', 1, 1);
  });
});

$(window).on("load", function () {
  // code here
  $('body:not(.is-request-for-quotation) input[name="payment_method"]').each(
    function () {
      this.checked = false;
    }
  );

  $('body.is-request-for-quotation input[name="payment_method"]').each(
    function () {
      this.checked = true;
    }
  );

  $("body").on("updated_checkout", function () {
    const methods = $('input[name="payment_method"]');
    if (methods.length > 0 && methods[0].id == "payment_method_quotation") {
      methods[0].checked = true;
      console.log("do");
    }
  });
});
